import {EventEmitter, Injectable} from '@angular/core';
import {TenantService} from '../tenant/tenant.service';

@Injectable()
export class PakTenantService {
  private readonly PAK_DIV_ID = 'pak_iframe_div';
  private viewChangedEvent = new EventEmitter()

  constructor(private tenantService: TenantService) {}

  get getViewChangedEvent(): EventEmitter<any> {
    return this.viewChangedEvent;
  }

  loadIframeResizer(): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'assets/js/iframeResizer.contentWindow.min.js';
    document.head.appendChild(script);
  }

  addPakDiv(): void {
    if (!document.getElementById(this.PAK_DIV_ID)) {
      const div = document.createElement('div');
      div.id = this.PAK_DIV_ID;
      Object.assign(div.style, {clear: 'both', display: 'block', height: 0});
      div.setAttribute('data-iframe-height', '');
      document.body.appendChild(div);
    }
  }

  emitViewChangedEvent(): void {
    if (this.tenantService.isTenantPAK()) {
      this.viewChangedEvent.emit(null);
    }
  }
}
